import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { pageViewEvent, ctaClickEvent } from "../services/adobeDataLayer";

function Thankyou() {
    const [showSection, setThankYou] = useState(false);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/");
        ctaClickEvent("Back", "Thank you page", "button", 0, "na");
    };

    useEffect(() => {
        const type = localStorage.getItem("type");
        setThankYou(type);
    
    }, []);


// ------------Trigger once for all TY pages-------------

//-----------bing-----------
    //bing tag
    useEffect(() => {
        // Initialize UET queue if not already
        window.uetq = window.uetq || [];

        // Create the Bing UET script
        const script = document.createElement("script");
        script.src = "//bat.bing.com/bat.js";
        script.async = true;

        script.onload = script.onreadystatechange = function () {
            const rs = this.readyState;
            if (!rs || rs === "loaded" || rs === "complete") {
                const o = {
                    ti: "97123908",
                    enableAutoSpaTracking: true,
                };
                o.q = window.uetq;
                window.uetq = new window.UET(o);
                window.uetq.push("pageLoad");

                script.onload = script.onreadystatechange = null;
            }
        };

        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        }

        // Optional cleanup
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);


//-----------clarity-----------
      useEffect(() => {
            (function (c, l, a, r, i, t, y) {
              c[a] =
                c[a] ||
                function () {
                  (c[a].q = c[a].q || []).push(arguments);
                };
              t = l.createElement(r);
              t.async = 1;
              t.src = "https://www.clarity.ms/tag/" + i;
              y = l.getElementsByTagName(r)[0];
              y.parentNode.insertBefore(t, y);
            })(window, document, "clarity", "script", "tjdal8nflp");
          }, []);

    //-----------LinkedIn tag-----------
    useEffect(() => {
        // Set LinkedIn Partner ID
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push("7810465");

        // Create script tag for LinkedIn insight.min.js
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        }

        // Optional: Clean up the script on unmount
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);


    //-----------page view FB tags-----------
    useEffect(() => {
        const firePageView = () => {
            if (window.fbq) {
            window.fbq("track", "PageView");
            } else {
            setTimeout(firePageView, 300);
            }
        };

        firePageView();
        }, []);

    // global Gtag initiation
    useEffect(() => {
        // Inject gtag.js only once
        if (!document.getElementById("gtag-js")) {
            const script = document.createElement("script");
            script.id = "gtag-js";
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=AW-848956189"; // only one is needed
            document.head.appendChild(script);
        }

        const initGtag = () => {
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                window.dataLayer.push(arguments);
            }

            window.gtag = gtag;

            // Initialize gtag with both Ads tracking IDs
            gtag("js", new Date());
            gtag('config', 'AW-961178487');
            gtag("config", "AW-848956189");
        };

        // Initialize if already loaded, else wait for it
        if (window.gtag) {
            window.gtag('config', 'AW-961178487');
            window.gtag("config", "AW-848956189");
        } else {
            const existingScript = document.getElementById("gtag-js");
            existingScript?.addEventListener("load", initGtag);
        }
    }, []);

// ------------ Trigger based on condition -------------
//----AW-818835661----
        useEffect(() => {
        const type = localStorage.getItem("type");
        if (type === "1") {
            pageViewEvent("not eligible");
            const script = document.createElement("script");
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=AW-818835661";
            document.head.appendChild(script);

            // After the script loads, initialize gtag
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag;
                // Retrieve user data from localStorage
                const userData = localStorage.getItem("userData");
                const retrievedData = userData ? JSON.parse(userData) : null;
                // Set user data if available
                window.gtag("js", new Date());
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-818835661/rMXKCN_Njt8bEM3huYYD',
                    'value': 1.0,
                    'currency': 'INR'
                });

                window.gtag("config", "AW-818835661", { 
                allow_enhanced_conversions: true,
                });

                // set user data if available
                if (retrievedData?.mobile) {
                window.gtag("set", "user_data", {
                    phone_number: retrievedData.mobile
                });
                }

                // send conversion event
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-818835661/pf6kCNzNjt8bEM3huYYD',
                    'value': 1.0,
                    'currency': 'INR'
                });
                // custom event (optional)
                window.gtag("event", "form_submit", { 
                send_to: "AW-818835661" 
                });


            }

            // Remove userData from localStorage after 4 seconds using a separate function
            function removeUserData() {
                localStorage.removeItem("userData");
            }
            setTimeout(removeUserData, 4000);
        }
        else {
            // EL Adobe Event
            pageViewEvent("not eligible");
            const script = document.createElement("script");
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=AW-818835661";
            document.head.appendChild(script);
            // After the script loads, initialize gtag
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag;
                // Retrieve user data from localStorage
                const userData = localStorage.getItem("userData");
                const retrievedData = userData ? JSON.parse(userData) : null;
                // Set user data if available
            window.gtag("js", new Date());
              window.gtag('event', 'conversion', {
      'send_to': 'AW-818835661/rMXKCN_Njt8bEM3huYYD',
      'value': 1.0,
      'currency': 'INR'
  });
            window.gtag("config", "AW-818835661", { 
            allow_enhanced_conversions: true
            });

            // set user data if available
            if ( retrievedData?.mobile) {
            window.gtag("set", "user_data", {
                phone_number: retrievedData.mobile
            });
            }

            // send conversion event
            window.gtag('event', 'conversion', {'send_to': 'AW-818835661/U7-5CJzx9eQZEM3huYYD'});
            // custom event (optional)
            window.gtag("event", "form_submit", { 
            send_to: "AW-818835661" 
            });
            }

            // Remove userData from localStorage after 4 seconds using a separate function
            function removeUserData() {
                localStorage.removeItem("userData");
            }
            setTimeout(removeUserData, 4000);
        }
    }, [])

// FB tags, DV 360

 useEffect(() => {
        const type = localStorage.getItem("type");
        setThankYou(type);
        //not-eligible
        if (type === "1") {
            // pageViewEvent("not eligible");

            //NEL invmedia
            const script = document.createElement("script");
            script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
            script.async = true;
            document.head.appendChild(script);

            // Initialize gtag after script loads
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag; // make globally available
                gtag("js", new Date());
                gtag("config", "DC-8971752");
                gtag("event", "conversion", {
                    allow_custom_scripts: true,
                    send_to: "DC-8971752/invmedia/icici033+standard",
                });
                gtag('event', 'conversion', {
    'allow_custom_scripts': true,
    'send_to': 'DC-8971752/invmedia/icici034+standard'
  });
            };

            // NEL FB tags
            const loadFbqScript = () => {
                return new Promise((resolve) => {
                    if (window.fbq) return resolve(); // Already loaded
                    (function (f, b, e, v, n, t, s) {
                        if (f.fbq) return;
                        n = f.fbq = function () {
                            n.callMethod
                                ? n.callMethod.apply(n, arguments)
                                : n.queue.push(arguments);
                        };
                        if (!f._fbq) f._fbq = n;
                        n.push = n;
                        n.loaded = true;
                        n.version = "2.0";
                        n.queue = [];
                        t = b.createElement(e);
                        t.async = true;
                        t.src = v;
                        s = b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t, s);
                        t.onload = resolve;
                    })(
                        window,
                        document,
                        "script",
                        "https://connect.facebook.net/en_US/fbevents.js"
                    );
                });
            };

            const initializePixels = () => {
                if (!window.fbq) return;

                // Initialize both pixels
                window.fbq("init", "1109423764622443"); // Pixel B
                window.fbq("trackSingleCustom", "1109423764622443", "Alumni-All-Cards-NEL-Jan26");
                window.fbq("trackSingleCustom", "1109423764622443", "Alumni-All-Cards-Leads-Jan26");
           
            };

            loadFbqScript().then(() => {
                initializePixels();
            });
        }

        else {

            // EL Adobe Event
            // pageViewEvent("eligible");

            //EL invmedia
            const script = document.createElement("script");
            script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
            script.async = true;
            document.head.appendChild(script);

            // Initialize gtag after script loads
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag; // make globally available
                gtag("js", new Date());
                gtag("config", "DC-8971752");
                gtag("event", "conversion", {
                    allow_custom_scripts: true,
                    send_to: "DC-8971752/invmedia/icici032+standard",
                });
                gtag('event', 'conversion', {
    'allow_custom_scripts': true,
    'send_to': 'DC-8971752/invmedia/icici034+standard'
  });

            };

            // //EL Twitter
            // if (typeof window.twq === "function") {
            //     window.twq("event", "tw-py3bg-q9hdu", {});
            // }

            // EL FB tags
            const loadFbqScript = () => {
                return new Promise((resolve) => {
                    if (window.fbq) return resolve(); // Already loaded
                    (function (f, b, e, v, n, t, s) {
                        if (f.fbq) return;
                        n = f.fbq = function () {
                            n.callMethod
                                ? n.callMethod.apply(n, arguments)
                                : n.queue.push(arguments);
                        };
                        if (!f._fbq) f._fbq = n;
                        n.push = n;
                        n.loaded = true;
                        n.version = "2.0";
                        n.queue = [];
                        t = b.createElement(e);
                        t.async = true;
                        t.src = v;
                        s = b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t, s);
                        t.onload = resolve;
                    })(
                        window,
                        document,
                        "script",
                        "https://connect.facebook.net/en_US/fbevents.js"
                    );
                });
            };

            const initializePixels = () => {
                if (!window.fbq) return;

                // Initialize both pixels
                window.fbq("init", "1109423764622443"); // Pixel B
                window.fbq("trackSingleCustom", "1109423764622443", "Alumni-All-Cards-EL-Oct24-New");
                window.fbq("trackSingleCustom", "1109423764622443", "Alumni-All-Cards-Leads-Jan26");

           
            };

            loadFbqScript().then(() => {
                initializePixels();
            });
        }
    }, []);


    return (
        <>
        {/* <MetaPixelPageView /> */}
            {/* Not Eligible */}
            {showSection === "1" && (
                <section>
                    <div className="container">
                        <div className="thank-you">
                            <button
                                onClick={handleClick}
                                className="free_back thank_you_back"
                            >
                                <img
                                    src="../dist/img/back_white.svg"
                                    width="12px"
                                    alt="Arrow"
                                />
                                Back
                            </button>

                            <div className="margin-top thankyou-wrap" style={{ position: "relative" }}>
                                <div className="row justify-content-between">
                                    <div className="col-md-6">
                                        <div className="popup-icon">
                                            <img
                                                src="../dist/img/thank-you.svg"
                                                width="122"
                                                height="122"
                                                alt="Thanks"
                                            />
                                        </div>

                                        <h2>
                                            Thank you for <br /> reaching out to us.
                                        </h2>
                                       
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mobilebx">
                                            <h3 className="orange">
                                                We are currently reviewing your profile. <br />
                                                If you meet the eligibility criteria, <br />
                                                our team will get in touch with you shortly.
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            {/* Self Employed */}
            {showSection === "2" && (
                <section>
                    <div className="container">
                        <div className="thank-you">
                            <button
                                onClick={handleClick}
                                className="free_back thank_you_back"
                            >
                                <img
                                    src="../dist/img/back_white.svg"
                                    width="12px"
                                    alt="Arrow"
                                />
                                Back
                            </button>

                            <div className="margin-top thankyou-wrap" style={{ position: "relative" }}>
                                <div className="row justify-content-between">
                                    <div className="col-md-6">
                                        <div className="popup-icon">
                                            <img
                                                src="../dist/img/check.svg"
                                                width="122"
                                                height="122"
                                                alt="Thanks"
                                            />
                                        </div>

                                        <h2>
                                            Thank you for choosing <br /> ICICI Bank Credit Card
                                        </h2>
                                        <h3> You will get a call from our team <br />
                                        from number starting with <br />
                                        1600 31 XXXX.
                                       </h3>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mobilebx">
                                            <div className="icon-heading">
                                                <img src="../dist/img/approve.svg" width="46" alt="" />
                                                <span>
                                                    Please keep the list of below <br /> documents handy
                                                </span>
                                            </div>

                                            <ol className="orderlist">
                                                 <li>PAN Card</li>
                                                <li>Aadhar Card - Please ensure that first 8 digits of Aadhar number are masked</li>
                                                <li>Bank Statement (last 3 months)</li>
                                                <li>Salary Slip* (last 3 months)</li>
                                                <li>Blank Paper and Pen</li>
                                            </ol>

                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            {/* Salaried Eligible */}
            {showSection === "3" && (
                <section>
                    <div className="container">
                        <div className="thank-you">
                            <button
                                onClick={handleClick}
                                className="free_back thank_you_back"
                            >
                                <img
                                    src="../dist/img/back_white.svg"
                                    width="12px"
                                    alt="Arrow"
                                />
                                Back
                            </button>

                            <div className="margin-top thankyou-wrap" style={{ position: "relative" }}>
                                <div className="row justify-content-between">
                                    <div className="col-md-6">
                                        <div className="popup-icon">
                                            <img
                                                src="../dist/img/check.svg"
                                                width="122"
                                                height="122"
                                                alt="Thanks"
                                            />
                                        </div>

                                        <h2>
                                            Thank you for choosing <br /> ICICI Bank Credit Card
                                        </h2>
                                        <h3> You will get a call from our team <br />
                                        from number starting with <br />
                                        1600 31 XXXX.
                                       </h3>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mobilebx">
                                            <div className="icon-heading">
                                                <img src="../dist/img/approve.svg" width="46" alt="" />
                                                <span>
                                                    Please keep the list of below <br /> documents handy
                                                </span>
                                            </div>

                                            <ol className="orderlist">
                                                 <li>PAN Card</li>
                                                <li>Aadhar Card - Please ensure that first 8 digits of Aadhar number are masked</li>
                                                <li>Bank Statement (last 3 months)</li>
                                                <li>Salary Slip* (last 3 months)</li>
                                                <li>Blank Paper and Pen</li>
                                            </ol>

                                            <p className="blackc">*If your Aadhar card number is visible on the salary slip, then please ensure that the first 8 digits of Aadhar card number are masked.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
}

export default Thankyou;
